import React, { useState } from "react";
import MainContainer from "../../components/partials/maincontainer";
import { IconButton } from "../../components/partials/btn";
// import { Icon } from "@iconify/react";
import RequestTable from "../../components/tables/requesttable";
import { useRequestStore } from "../../data/stores/loggerStore";
import { FlowSelectDropdown } from "../../components/partials/select";
import { dataStatus2 } from "../../utils/types";
import { SearchInput } from "../../components/partials/inputs";

const Requests = () => {
  const [activeTab, setActiveTab] = useState("view-all"),
    [statusText, setStatusText] = useState(""),
    [search, setSearch] = useState(""),
    { allData }: any = useRequestStore();

  return (
    <div>
      <MainContainer>
        <div className="bg-transparent main-border main-shadow rounded-lg">
          <div
            style={{
              borderBottom: "1px solid #D7E2EC",
            }}
            className="h-24 w-full px-5 flex justify-between items-center"
          >
            <div>
              <div className="flex gap-2 items-center">
                <h4 className="text-lg font-medium text-sec">Requests</h4>
                <button className="h-6 px-5 bg-[#E6F3FE] rounded-lg text-xs font-medium text-[#2070B8]">
                  {allData?.totalDocs}{" "}
                  {allData?.totalDocs > 1 ? "Requests" : "Request"}
                </button>
              </div>
              <p className="text-sm text-es-gray-100 mt-1 font-normal">
                Keep track of request updates
              </p>
            </div>
            <div className="flex gap-5 items-center">
              {process.env.REACT_APP_MAIN_URL && (
                <IconButton
                  onClick={() => {
                    const url = `${process.env.REACT_APP_MAIN_URL}/request`;
                    if (navigator.share) {
                      navigator.share({
                        title: `Esawas Request Form`,
                        text: `Share Esawas Request Form`,
                        url,
                      });
                    }
                    console.log({ url });
                  }}
                  icon="material-symbols:content-copy-outline"
                  color="white"
                  text="Copy Request Link"
                  bg="#2070B8"
                />
              )}
            </div>
          </div>

          <div
            style={{
              borderBottom: "1px solid #D7E2EC",
            }}
            className="h-20 w-full px-5 flex justify-between items-center"
          >
            <div className="inline-flex h-11 rounded-lg main-border overflow-hidden">
              <button
                className={`px-6  text-sm font-medium ${
                  activeTab === "view-all"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("view-all")}
              >
                View all
              </button>
              <div className="h-full w-px bg-[#d0d5dd]" />
              <button
                className={`px-6 text-sm font-medium ${
                  activeTab === "newly-uploaded"
                    ? "bg-[#F9FAFB] text-gray-800"
                    : "bg-transparent text-gray-600 hover:text-gray-800"
                }`}
                onClick={() => setActiveTab("newly-uploaded")}
              >
                Newly Uploaded
              </button>
            </div>
            <div className="flex gap-4 items-center">
              <SearchInput
                value={search}
                onChange={(e) => {
                  setSearch(e);
                }}
              />
              <FlowSelectDropdown
                options={[
                  { title: "All" },
                  ...dataStatus2?.map((it) => {
                    return { title: it };
                  }),
                ]}
                onChange={(d: any) => {
                  setStatusText(d?.title === "All" ? "" : d?.title);
                }}
              />
              {/* <IconButton icon="famicons:filter" text="Filter" /> */}
            </div>
          </div>
          <RequestTable
            usecase={activeTab}
            statusText={statusText}
            search={search}
          />
        </div>
      </MainContainer>
    </div>
  );
};

export default Requests;
